import { cn } from "@/lib/utils";
import { useWalletInfo } from "@reown/appkit/react";
import { UnplugIcon } from "lucide-react";
import { useTranslations } from "next-intl";

interface Props {
  readonly className?: string;
  readonly showName?: boolean;
}

export function WalletImage(props: Props) {
  const { walletInfo } = useWalletInfo();
  const t = useTranslations("Sidebar.left.dropdown");

  if (!walletInfo || !walletInfo.icon || !walletInfo.name) {
    return (
      <>
        <UnplugIcon className={cn("size-4", props.className)} />
        {t("disconnectWallet")}
      </>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={walletInfo.icon}
        alt={walletInfo.name}
        className={cn("size-4", props.className)}
        width="32"
        height="32"
      />
      {props.showName ? <span>{walletInfo.name}</span> : null}
    </>
  );
}
